import { RefObject, useCallback, useRef } from 'react';
import { useAppDispatch } from '@customer/store/hooks';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

type Return = [RefObject<HTMLVdsBasicInputElement>, (value: number | null) => void];

export const useNumberInput = (action: ActionCreatorWithPayload<number | null>): Return => {
  const dispatch = useAppDispatch();

  const ref = useRef<HTMLVdsBasicInputElement>(null);

  const onChange = useCallback(
    (value: number | null) => {
      dispatch(action(value));
    },
    [dispatch, action],
  );

  return [ref, onChange];
};

export default useNumberInput;
